import { ProductsPageDE } from 'components/ProductsPageDE/ProductsPageDE';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useLocale } from 'hooks/useLocale';
import { getCookie } from 'utils/cookieHelper';
import { ProductsDE } from './ProductsDE/ProductsDE';
import { ProductsSkeleton } from './ProductsSkeleton/ProductsSkeleton';
import { ProductsUK } from './ProductsUK/ProductsUK';

export const Products = () => {
  const { isDE } = useLocale();
  const { isContextLoading, isIntroducerLoading } = useIntroducerData();
  const showOldDEPage = getCookie('showOldProductsPage') === 'true';

  if (isContextLoading || isIntroducerLoading) {
    return <ProductsSkeleton />;
  }

  if (!isDE) return <ProductsUK />;
  return showOldDEPage ? <ProductsPageDE /> : <ProductsDE />;
};
